import React, { Component } from 'react';
import s from './Profile.css';
import masa_thumb from './masa_thumb.jpg';

export default class Profile extends Component {
  render(){
    return pug`
      div(className=s.profile)
        img(className=s.image src=masa_thumb)
      
        h3(className=s.name) 石井将文
        p 1991年11月9日 山形県天童市生まれ。26歳。蠍座。B型。
          br
          | 2014年3月 電気通信大学 次席にて卒業
          br
          | 2018年3月 電気通信大学大学院 修了
          br
          | 2018年4月 三重大学大学院忍者・忍術学コース入学/在学中
          br
          | 2018年9月 株式会社ベイス 入社
          br
          | 2019年11月 株式会社ベイス 退社 ／ 独立
          
    `;
  }
}



// WEBPACK FOOTER //
// ./src/Profile.js